module.exports = __webpack_public_path__ + "img/star.cee0f0bc.svg";